import { useContext } from 'react';
import { StoreContext } from 'Models/Store';

export default function useStore() {
	return useContext(StoreContext);
}
